import { useState } from 'react'
import { TextField } from '@nv/basic-components'
import FileUploaderModal from './file_uploader/FileUploader'
import UploadedDocument from './uploaded_doc/UploadedDocument'

const DocumentInputUpload = ({ formik, textFieldName, documentFieldName, label, style = {}, setUploadErr }: any) => {
  const [localFileData, setLocalFileData] = useState(null)

  return (
    <div style={style}>
      <TextField formik={formik} type='text' field={textFieldName} placeholder={label} label={label} />

      {localFileData ? (
        <UploadedDocument localFile={localFileData} onChangeFile={() => setLocalFileData(null)} />
      ) : (
        <FileUploaderModal
          setUploadErr={setUploadErr}
          onCallback={(res) => {
            setLocalFileData({ name: res.data.name, file: res.data.file })
            formik.setFieldValue(documentFieldName, {
              name: res.data.name,
              file: res.data.file,
            })
          }}
        />
      )}
    </div>
  )
}

export default DocumentInputUpload
